<template>
  <span :class="clazz"
        :title="event.eventName"
        @click="onClick"
        @mouseover="onHover"
        @mouseleave="onLeave"
        ref="event">
    <span class="event-symbol" :style="style">
      <i v-if="event.markStatus" class="icon-star_glyph"></i>
    </span>
    <span class="event-name">{{nameFormat(event)}}</span>
  </span>
</template>

<script>
import {util} from '../../utils'
export default {
  name: 'eventNode',
  props: {
    event: null,
    playTime: {
      type: Number,
      default: 0
    }
  },
  computed: {
    clazz () {
      return {
        'event-node': true,
        marked: this.event.markStatus
      }
    },
    color () {
      const colors = ['#00a0e9', '#aaabd3', '#f4b93b', '#85bd41', '#f29c9f', '#0068b7', '#f29b76', '#ea68a2', '#8f82bc', '#f29b76']
      const name = this.event.eventName
      let num = 0
      for (let i = 0; i < name.length; i++) {
        num += name.charCodeAt(i)
      }
      num = num + ''
      return this.event.markStatus ? '#fccb15' : colors[num.charAt(num.length - 1)]
    },
    style () {
      return {
        color: this.event.status === 0 ? this.color : '#dadada',
        borderColor: this.event.status === 0 ? this.color : '#dadada'
      }
    }
  },
  watch: {
    playTime (time) {
      if (time >= this.event.time) {
        this.onHover()
      } else {
        this.onLeave()
      }
    }
  },
  methods: {
    nameFormat (event) {
      let name = event.eventName || '未知'
      if (event.eventId === -1) name = '会话开始'
      if (event.eventId === -2) name = '会话结束'
      return util.strMiddleSplit(name, {
        maxLength: 16,
        beginLength: 16,
        endLength: 0,
        replaceStr: '...'
      })
    },
    onHover (trigger) {
      let dom = this.$refs.event.querySelector('.event-symbol')
      dom.style.borderColor = dom.style.color = this.color
      this.$refs.event.querySelector('.event-name').style.color = '#354052'
      if (trigger) this.$emit('hover', this.event)
    },
    onLeave (trigger) {
      if (this.event.status === 0) return
      let dom = this.$refs.event.querySelector('.event-symbol')
      dom.style.borderColor = dom.style.color = '#dadada'
      this.$refs.event.querySelector('.event-name').style.color = '#BCBEC2'
      if (trigger) this.$emit('leave', this.event)
    },
    onClick () {
      this.$emit('click', this.event)
    }
  }
}
</script>

<style lang="sass">
@import "styles/eventNode"
</style>
